import React from 'react';

const Title: React.FC = ({ children }) => (
  <h5 className="text-36 font-light text-gray-500 text-center">{children}</h5>
);

export default Title;
